import React from 'react';
import { motion } from 'framer-motion';
import { reveal } from '../utils/motion';
import { CaseStudyCard } from '../components/CaseStudyCard';
import { SiteHeader } from '../components/SiteHeader';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { caseStudies, heroMetrics } from '../data/caseStudies';
import { clientLogos } from '../data/clientLogos';
import { linkClass } from '../utils/linkClass';
export function Home() {
  return <div className="min-h-screen w-full bg-white font-sans text-ink" data-id="element-116" data-mp="24h0qy1bdf38x">
      <div className="mx-auto flex max-w-[1347px] flex-col gap-[30px] px-5 py-10 md:px-10" data-id="element-117" data-mp="24hag5mold6dk">
        <SiteHeader data-id="element-118" data-mp="29ek6d4jt1m2g" />

        <main className="flex flex-col gap-[30px]" data-id="element-119" data-mp="29ihqnti4cjnx">
          <section className="flex flex-col-reverse gap-6 py-4 min-[700px]:flex-row min-[700px]:items-center min-[700px]:gap-[60px] md:py-8" data-id="element-120" data-mp="2dirsctyvonwz">
            <div className="flex flex-1 flex-col justify-end gap-5" data-id="element-121" data-mp="3kxmu4zq2qm8l">
              <motion.div className="flex flex-col gap-3" initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={reveal} data-id="element-122" data-mp="3ovarsaj5it46">
                <h1 className="text-headline font-semibold" data-id="element-123" data-mp="2vyhtk4qlcute">
                  18 years of experience across B2B SaaS, fintech, and healthcare.
                </h1>
                <p className="text-subhead text-muted" data-id="element-124" data-mp="2mxs037oszgiu">
                  Specialize in driving business results through improved usability.
                </p>
              </motion.div>
            </div>
            <motion.img src="https://cdn.magicpatterns.com/uploads/oThdsUnkXC7FRqpUL19do3/Meikson-Square.jpg" alt="Portrait of Michael Meikson" className="aspect-square w-[160px] shrink-0 rounded-full object-cover min-[700px]:w-[200px]" initial={{
            opacity: 0,
            x: 60
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            ...reveal,
            delay: 0.05
          }} data-id="element-125" data-mp="2d65t5nji03lw" />
          </section>

          <ul aria-label="Results" className="grid w-full grid-cols-1 gap-[30px] sm:grid-cols-3" data-id="element-126" data-mp="1kkqn7fgjeeeh">
            {heroMetrics.map((m, i) => <motion.li key={m.label} className="flex flex-col rounded-[30px] bg-positive-bg p-5 [container-type:inline-size]" initial={{
            opacity: 0,
            y: 24
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            ...reveal,
            delay: 0.15 + i * 0.06
          }} data-id="element-127" data-mp="1ondhro4ledfd" data-mpi={i}>
                <span className="whitespace-nowrap text-[clamp(22px,21cqw,40px)] font-normal leading-[1.35] tracking-[-0.02em] text-positive" data-id="element-128" data-mp="23dbbejlajvby">
                  {m.value}
                </span>
                <span className="text-xl leading-[27px] tracking-[-0.02em]" data-id="element-129" data-mp="1tl5csr0jafns">{m.label}</span>
              </motion.li>)}
          </ul>

          <motion.section aria-label="Clients" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          ...reveal,
          delay: 0.4
        }} data-id="element-130" data-mp="2m9kmcy0wc5rq">
            <ul className="grid grid-cols-3 items-center gap-x-4 gap-y-2 md:grid-cols-6" data-id="element-131" data-mp="flahzgvjp615">
              {clientLogos.map(logo => <li key={logo.name} className="flex items-center justify-center" data-id="element-132" data-mp="am7psx0nyual">
                  <img src={logo.src} alt={logo.name} className="block aspect-[2/1] w-full max-w-[200px] object-contain" data-id="element-133" data-mp="od2qvn4x873m" />
                </li>)}
            </ul>
          </motion.section>

          <section aria-label="Case studies" className="flex flex-col gap-[30px]" data-id="element-134" data-mp="3stdp7dytfllj">
            {caseStudies.map(study => <CaseStudyCard key={study.id} study={study} animate data-id="element-135" data-mp="3nv3oyoy8hut2" />)}
          </section>

          <section className="flex flex-col gap-[30px] pt-2" data-id="element-136" data-mp="5ljnvgawct1l">
            <div className="flex flex-col gap-3" data-id="element-137" data-mp="ni40t5ncpp2">
              <h2 className="text-headline font-semibold" data-id="element-138" data-mp="qw8c6xvf8z5">
                AI has become the core of my design practice.
              </h2>
              <p className="text-subhead text-muted" data-id="element-139" data-mp="1c4hv5lg9cyhi">
                I prototype in code and can ship working software.
              </p>
            </div>
            <div className="grid grid-cols-1 gap-[30px] md:grid-cols-[minmax(0,1fr)_minmax(0,2fr)]" data-id="element-140" data-mp="27g9dnwqz37pp">
              <div className="flex flex-col gap-10" data-id="element-141" data-mp="2cesxnrm0a9ff">
              <div className="flex flex-col gap-4 text-base leading-[1.6]" data-id="element-142" data-mp="2hb9myp4xytu3">
                <p data-id="element-143" data-mp="2mbp1hk0ym7dn">
                  My primary design tool is Magic Patterns, where I maintain working prototypes of client projects. 
                </p>
                <a href="https://project-unified-inbox-with-filtering-117.magicpatterns.app/" target="_blank" rel="noopener noreferrer" className={`w-fit text-base ${linkClass}`} data-id="element-144" data-mp="2qaobhj1jsuby">
                  View RSI Prototype →
                </a>
              </div>
              <div className="flex flex-col gap-4 text-base leading-[1.6]" data-id="element-145" data-mp="3a1jblttw9hu7">
                <p data-id="element-146" data-mp="3e2247q3m2rxg">
                  I built Percelo, an AEO (Answer Engine Optimization), tool solo in about two weeks with Claude Code. 
                </p>
                <a href="https://www.percelo.com" target="_blank" rel="noopener noreferrer" className={`w-fit text-base ${linkClass}`} data-id="element-147" data-mp="12gb38c1ccasb">
                  Try Percelo →
                </a>
              </div>
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/8x9mJt8jkvyUyDgp9GG3CK/Percelo-hero2.png" alt="Percelo AI visibility report open on a laptop" className="h-[325px] w-full self-start rounded-[30px] object-cover object-[50%_45%]" data-id="element-148" data-mp="ohjs8yhrz58e" />
            </div>
          </section>

          <TestimonialsSection data-id="element-149" data-mp="17eupkdjujol7" />
        </main>

        <div className="pt-10" data-id="element-150" data-mp="17bytyvvh1bzx">
          <SiteHeader as="footer" data-id="element-151" data-mp="24t70v5oz385x" />
        </div>
      </div>
    </div>;
}